module.exports = __webpack_public_path__ + "img/media.95c065d5.svg";